export default {
  BRUSH_SMALL: 'BRUSH_SMALL',
  BRUSH_LARGE: 'BRUSH_LARGE',
  BRUSH_TILT_UD: 'BRUSH_TILT_UD',
  BRUSH_TILT_DU: 'BRUSH_TILT_DU',
};
